export default __webpack_public_path__ + "static/media/Rectangle 75.d19bb545.png";